import { FC } from 'react';

import { DetailsSection } from '@/components/SectionWithCard';
import { useSavedQuery } from '@/hooks/dbtStrategy/useSavedQuery';
import { QueryParamsSegment } from '@/pages/account/project/resource/details/components/Sections/QueryParamsSegment';
import { ResourceDetailsParams } from './panelDetailTypes';

export const SavedQueryParamsTable: FC<ResourceDetailsParams> = ({
  className,
  children,
  compact,
  ...props
}) => {
  const savedQueryQuery = useSavedQuery(props.uniqueId);
  const savedQuery = savedQueryQuery.data.definition;
  if (!savedQuery) {
    return null;
  }
  const whereContent = savedQuery.queryParams.where?.whereFilters
    .map((whereFilter) => whereFilter.whereSqlTemplate)
    .filter((x) => x !== null) as string[] | undefined;
  const orderContent = savedQuery.queryParams.orderBy?.filter((x) => x !== null) as
    | string[]
    | undefined;
  return (
    <DetailsSection heading="Parameters" withCard={false}>
      <div className="overflow-hidden rounded-md border border-borderMuted">
        <QueryParamsSegment
          segmentName={'Metrics'}
          content={savedQuery.queryParams.metrics}
        />
        <QueryParamsSegment
          segmentName={'Group By'}
          content={savedQuery.queryParams.groupBy}
        />
        <QueryParamsSegment segmentName={'Where'} content={whereContent} />
        <QueryParamsSegment segmentName={'Order By'} content={orderContent} />
        {savedQuery.queryParams.limit && (
          <QueryParamsSegment
            segmentName={`Limit: ${savedQuery.queryParams.limit}`}
            content={[]}
          />
        )}
      </div>
    </DetailsSection>
  );
};
